import { FC } from "react";
import { Divider, Stack, Typography } from "@mui/material";
import { useAppSelector } from "../../../../../../../../../../store/hooks";
import { largestCostChangesSetupPropertyByKeySelector } from "../../../../../../../../../../store/dashboards/selectors/setups/larges-cost-changes/largestCostChangesSetupPropertyByKeySelector";
import { LargestCostChangesWidgetHeaderCardSourceData } from "../../../../../../widgets/largest-cost-change/components/header/LargestCostChangesWidgetHeaderCardSourceData";
import { largestCostChangesSetupWidgetTitleSelector } from "../../../../../../../../../../store/dashboards/selectors/setups/larges-cost-changes/largestCostChangesSetupWidgetTitleSelector";
import { widgetREPrevDateDetailsSelector } from "../../../../../../../../../../store/dashboards/selectors/widgets/common/widget-re-view/WidgetREPrevDateDetailsSelector";

interface LargestCostChangeWidgetSetupHeaderProps {
  widgetId?: string;
}
export const LargestCostChangesWidgetSetupHeader: FC<
  LargestCostChangeWidgetSetupHeaderProps
> = ({ widgetId }) => {
  const name = useAppSelector(
    largestCostChangesSetupPropertyByKeySelector("name"),
  );
  const date = useAppSelector(
    largestCostChangesSetupPropertyByKeySelector("date"),
  );

  const prevDateDetails = useAppSelector((state) =>
    widgetREPrevDateDetailsSelector(state, widgetId),
  );

  const widgetTitleProps = useAppSelector(
    largestCostChangesSetupWidgetTitleSelector,
  );

  return (
    <Stack direction="row">
      <Stack px={2} py={1}>
        <Typography variant="body1" fontWeight="bold" minHeight={24}>
          {name}
        </Typography>

        <Stack direction="row" alignItems="center" spacing={0.5}>
          <LargestCostChangesWidgetHeaderCardSourceData
            prevDate={prevDateDetails}
            date={date}
            {...widgetTitleProps}
          />
        </Stack>
      </Stack>
      <Divider />
    </Stack>
  );
};
